import { HttpContextToken } from '@angular/common/http';

/** @todo use it to add / remove token in @class HttpBackendInterceptor */
export const IS_PUBLIC_API = new HttpContextToken<boolean>(() => false);
